var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('grid',{ref:"grid",staticClass:"contract_list",attrs:{"data":_vm.rows,"columns":_vm.columns,"height":null,"autoHeight":true}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }